import { lazy } from "react";
import ArtifialIntelligence from "../AI/App";
import RemarkList from "../components/remark/RemarkList";
// Lazy load components for better performance
const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
const Mapsale = lazy(() => import("../pages/dashboard/Mapsale"));
const About = lazy(() => import("../pages/about/About"));
const SignIn = lazy(() => import("../pages/auth/SignIn"));
const MenuMagement = lazy(() => import("../manuManagement/ManuManagement"));
const DistrictWiseApplicationStatus = lazy(
  () => import("../components/reports/DistrictWiseApplicationStatus")
);
const Count = lazy(() => import("../components/count/Count"));

const routes = [
  // {
  //   path: "/",
  //   element: SignIn,
  // },
  {
    path: "/about",
    element: About,
  },
  {
    path: "/chart/:id",
    element: Dashboard,
  },

  {
    path: "/remark",
    element: RemarkList,
  },

  {
    path: "/remark-details",
    element: RemarkList,
  },

  {
    path: "/chart/:id/:districtCode",
    element: Dashboard,
  },

  {
    path: "/menuManagement",
    element: MenuMagement,
  },
  {
    path: "/count",
    element: Count,
  },

  {
    path: "/mapsale",
    element: Mapsale,
  },

  {
    path: "/aiassistant",
    element: ArtifialIntelligence,
  },
];

export default routes;
